// extracted by mini-css-extract-plugin
module.exports = {"managed_by":"managed_by--ManagedByNote-components__2wzee","managedBy":"managed_by--ManagedByNote-components__2wzee"};